<!--
 * @Author: Vanny
 * @Date: 2018-10-15 15:04:28
 * @LastEditors: Vanny
 * @LastEditTime: 2019-11-13 16:17:53
 * @Description: 
 -->
<template>
  <div class="list">
    <div v-for="(item, index) in list" :key="`${item.name}_${index}`">
      <router-link :to="item.url" v-if="item.url">
        <p>
          <span v-if="showArticle" class="icon-article" />
          <span>{{ item.name }}</span>
          <span class="pull-right icon-next"></span>
        </p>
      </router-link>
      <p @click="jump(item.native)" v-else>
        <span v-if="showArticle" class="icon-article" />
        <span>{{ item.name }}</span>
        <span class="pull-right icon-next"></span>
      </p>
    </div>
  </div>
</template>

<script>
import native from '@/utils'

const { NativeFuncs, callNativeAsyncFunc } = native

export default {
  props: {
    list: {
      type: Array,
      default: [],
    },
    showArticle: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    jump: function(url) {
      if (url) {
        callNativeAsyncFunc(NativeFuncs.SYSTEM.OPEN_WINDOW, url)
      }
    },
  },
}
</script>

<style lang="scss">
@import '../../../style/func.scss';

.list {
  font-size: px2rem(16px);
  background-color: #fff;

  > div {
    position: relative;
    p {
      position: relative;
      margin: 0;
      padding: px2rem(11px) px2rem(12px);
      border-bottom: 1px solid #e5e5e5;

      .icon-article {
        position: absolute;
        top: px2rem(14px);
        left: px2rem(14px);
        color: #0179fe;
        font-size: px2rem(16px);

        + span {
          padding-left: px2rem(24px);
        }
      }

      span {
        display: inline-block;
        max-width: 85%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .pull-right {
      position: absolute;
      top: 50%;
      right: px2rem(12px);
      transform: translateY(-50%);

      &.icon-next {
        color: #9b9b9b;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/help-center/components/List.vue